angular.module('shbdeployer.integrations.storidge').controller('StoridgeProfileSelectorController', [
  'StoridgeProfileService',
  'Notifications',
  function (StoridgeProfileService, Notifications) {
    var ctrl = this;

    this.$onInit = $onInit;
    function $onInit() {
      StoridgeProfileService.profiles()
        .then(function success(data) {
          ctrl.profiles = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить профили Storidge');
        });
    }
  },
]);
